// Modules
import { gql } from '@apollo/client'

export const CheckBiometryResult = gql`
    query checkBiometryResult($federalTaxId: String!, $unicoId: String!) {
        checkBiometryResult(federalTaxId: $federalTaxId, unicoId: $unicoId) {
            status
        }
    }
`

export const CheckUpdateContactBiometryLimit = gql`
    query checkUpdateContactBiometryLimit($federalTaxId: String!) {
        checkUpdateContactBiometryLimit(federalTaxId: $federalTaxId) {
            status
        }
    }
`
